// extracted by mini-css-extract-plugin
export default {"content":"_3V3jz"};